import PropTypes from "prop-types";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useCourseCustomLabels } from "@/react/components/Spaces/CourseSpace/Shared/useCourseCustomLabels";
import { Layout } from "@circle-react/components/shared/CustomizeUI";
import { useCurrentSpaceContext } from "@circle-react/contexts";
import { coursePaths } from "@circle-react/helpers/urlHelpers";
import { useOrderedLessons } from "@circle-react/hooks/courses/useOrderedLessons";
import { Typography } from "@circle-react-uikit/Typography";
import { LessonNavigation } from "../../../Shared/LessonNavigation";
import { LessonContent } from "./LessonContent";
import { LessonLocked } from "./LessonLocked";
import { QuizContent } from "./QuizContent";

export const Content = ({
  lesson,
  isDripped,
  drippedAt,
  isLessonPreview,
  onFeaturedMediaProgress,
  refetchLesson,
  lastAttempt,
  setLastAttempt,
  isLoadingLastAttempt,
}) => {
  const history = useHistory();
  const { data: space } = useCurrentSpaceContext();
  const { translatedLabels } = useCourseCustomLabels();
  const orderedLessons = useOrderedLessons({ spaceId: space?.id });
  const currentLessonIndex = orderedLessons.findIndex(l => l.id === lesson.id);

  return (
    <Layout.Main className="!bg-primary p-6 md:p-10">
      <div
        className="mx-auto max-w-[800px] space-y-8"
        data-testid="view-lesson-content"
      >
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <Typography.LabelSm>
              {t("courses.edit.lesson.position", {
                label: translatedLabels.lesson.singular,
                current: currentLessonIndex + 1,
                total: orderedLessons.length,
              })}
            </Typography.LabelSm>
            <Typography.TitleMd as="h2">{lesson.name}</Typography.TitleMd>
          </div>
          <LessonNavigation
            orderedLessons={orderedLessons}
            currentLessonIndex={currentLessonIndex}
            goToLesson={({ lessonId, sectionId, spaceSlug }) => {
              history.push(
                coursePaths.showLesson({
                  spaceSlug,
                  sectionId,
                  lessonId,
                }),
              );
            }}
          />
        </div>
        {(!isDripped || isLessonPreview) && (
          <LessonLocked
            isDripped={isDripped}
            drippedAt={drippedAt}
            lesson={lesson}
          />
        )}
        {(isDripped || isLessonPreview) && (
          <div
            className={classNames("space-y-8", { hidden: !isDripped })}
            data-testid="dripped-lesson-content"
          >
            {lesson.quiz ? (
              <QuizContent
                lesson={lesson}
                refetchLesson={refetchLesson}
                isLessonPreview={isLessonPreview}
                lastAttempt={lastAttempt}
                setLastAttempt={setLastAttempt}
                isLoadingLastAttempt={isLoadingLastAttempt}
              />
            ) : (
              <LessonContent
                lesson={lesson}
                onFeaturedMediaProgress={onFeaturedMediaProgress}
              />
            )}
          </div>
        )}
      </div>
    </Layout.Main>
  );
};

Content.propTypes = {
  lesson: PropTypes.object,
};
